import axios from 'axios'

export default function ReceiptSzamlazzhuImportService(formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/receipt/import/szamlazz/" + formData.company.id + "/" + formData.receiptGroupId,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
}
